import FJTextToSpeechLeft from '../view/FJTextToSpeechLeft.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJConstant from '../../../../constants/FJConstant.js';

const FJTextToSpeechLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const currentVoiceFromType = useSelector(state => state.textToSpeech.currentVoiceFromType);
    const currentAvatarUrl = useSelector(state => state.textToSpeech.currentAvatarUrl);
    const currentVoiceUrl = useSelector(state => state.textToSpeech.currentVoiceUrl);
    const currentName = useSelector(state => state.textToSpeech.currentName);
    const currentSpeed = useSelector(state => state.textToSpeech.currentSpeed);
    const currentStyle = useSelector(state => state.textToSpeech.currentStyle);
    const currentPitch = useSelector(state => state.textToSpeech.currentPitch);
    const recentUseVoiceList = useSelector(state => state.textToSpeech.recentUseVoiceList);
    const currentCountryInfo = useSelector(state => state.textToSpeech.currentCountryInfo);
    const currentStyleList = useSelector(state => state.textToSpeech.currentStyleList);

    const speechSelectId = useSelector(state => state.textToSpeech.speechSelectId);
    const currentSpeechList = useSelector(state => state.textToSpeech.currentSpeechList);

    const currentStatus = currentSpeechList.find(item => item.id === speechSelectId)?.status;

    const _resetBottomTime = () => {
        dispatch(FJActionTextToSpeech.updateBottomTotalTimeAction(0));
        dispatch(FJActionTextToSpeech.updateBottomCurrentTimeAction(0));
    };

    const _onChangeStyle = value => {
        dispatch(FJActionTextToSpeech.setSliceCurrentStyleAction(value));
        dispatch(FJActionTextToSpeech.updateCurrentItemInfoAction());
        _resetBottomTime();
    };

    const _onChangeSpeed = value => {
        dispatch(FJActionTextToSpeech.setSliceCurrentSpeedAction(Math.round(value * 10) / 10));
        dispatch(FJActionTextToSpeech.updateCurrentItemInfoAction());
        _resetBottomTime();
    };

    const _onChangePitch = value => {
        dispatch(FJActionTextToSpeech.setSliceCurrentPitchAction(Math.round(value * 10) / 10));
        dispatch(FJActionTextToSpeech.updateCurrentItemInfoAction());
        _resetBottomTime();
    };

    const _openLibraryModal = () => {
        dispatch(FJActionTextToSpeech.openLibraryModalAction());
    };

    const _onUse = (info, options) => {
        dispatch(FJActionTextToSpeech.useVoiceItemAction(info, options));
    };

    return (
        <FJTextToSpeechLeft
            currentVoiceFromType={currentVoiceFromType}
            currentAvatarUrl={currentAvatarUrl}
            currentVoiceUrl={currentVoiceUrl}
            currentName={currentName}
            currentSpeed={currentSpeed}
            currentStyle={currentStyle}
            currentPitch={currentPitch}
            recentUseVoiceList={recentUseVoiceList}
            onChangeStyle={_onChangeStyle}
            onChangeSpeed={_onChangeSpeed}
            onChangePitch={_onChangePitch}
            currentCountryInfo={currentCountryInfo}
            currentStyleList={currentStyleList}
            openLibraryModal={_openLibraryModal}
            isDisabled={currentStatus === FJConstant.GENERATING}
            onUse={_onUse}
        />
    );
};
export default FJTextToSpeechLeftContainer;
